import {bindActionCreators} from 'redux';

export const UPDATE_PARAMS_SEARCH = 'UPDATE_PARAMS_SEARCH';
export const updateParamsSearch = (query) => ({
  type: UPDATE_PARAMS_SEARCH,
  payload: query,
});

export const UPDATE_PARAMS_DROPDOWN_FILTER = 'UPDATE_PARAMS_DROPDOWN_FILTER';
export const updateParamsDropdownFilter = (state) => ({
  type: UPDATE_PARAMS_DROPDOWN_FILTER,
  payload: state,
});

export const UPDATE_PARAMS_PERIOD_FILTER = 'UPDATE_PARAMS_PERIOD_FILTER';
export const updateParamsPeriodFilter = (state) => ({
  type: UPDATE_PARAMS_PERIOD_FILTER,
  payload: state,
});

export const UPDATE_PARAMS_REMOVE = 'UPDATE_PARAMS_REMOVE';
export const updateParamsRemoveFilter = (key, removeValue) => ({
  type: UPDATE_PARAMS_REMOVE,
  payload: {key, removeValue},
});

export const UPDATE_PARAMS_UNIT_FILTER = 'UPDATE_PARAMS_UNIT_FILTER';
export const updateParamsUnitFilter = (state) => ({
  type: UPDATE_PARAMS_UNIT_FILTER,
  payload: state,
});

export const UPDATE_PARAMS_LOCATION_MARKET_FILTER =
  'UPDATE_PARAMS_LOCATION_MARKET_FILTER';
export const updateParamsLocationMarketFilter = (state) => ({
  type: UPDATE_PARAMS_LOCATION_MARKET_FILTER,
  payload: state,
});

export const getBoundQueryParamActions = (store) => ({
  dispatchParamsSearch: bindActionCreators(updateParamsSearch, store.dispatch),
  dispatchParamsDropdownFilter: bindActionCreators(
    updateParamsDropdownFilter,
    store.dispatch,
  ),
  dispatchParamsPeriodFilter: bindActionCreators(
    updateParamsPeriodFilter,
    store.dispatch,
  ),
  dispatchParamsRemoveFilter: bindActionCreators(
    updateParamsRemoveFilter,
    store.dispatch,
  ),
  dispatchParamsUnitFilter: bindActionCreators(
    updateParamsUnitFilter,
    store.dispatch,
  ),
  dispatchParamsLocationMarketFilter: bindActionCreators(
    updateParamsLocationMarketFilter,
    store.dispatch,
  ),
});
